import React from 'react'
import { VscFilePdf, VscFileZip, VscFile } from 'react-icons/vsc'
import appConfig from 'configs/app.config'

const BYTE = 1000
const getKB = (bytes) => Math.round(bytes / BYTE)

const FileIcon = ({ children }) => {
    return <span className="text-4xl">{children}</span>
}

const FileItem = (props) => {
    const { file, children } = props
    const { id, extension, name, uniqueName } = file

    const renderThumbnail = () => {
        if (extension === '.zip') {
            return (
                <FileIcon>
                    <VscFileZip />
                </FileIcon>
            )
        }

        if (extension === '.pdf') {
            return (
                <FileIcon>
                    <VscFilePdf />
                </FileIcon>
            )
        }

        return (
            <FileIcon>
                <VscFile />
            </FileIcon>
        )
    }

    return (
        <div className="upload-file">
            <div className="flex">
                <div className="upload-file-thumbnail">{renderThumbnail()}</div>
                <div className="upload-file-info">
                    <h6 className="upload-file-name"><a href={appConfig.blobPrefix + '/projects/' + uniqueName} taget="_blank">{name}</a></h6>
                    {/* <span className="upload-file-size">{getKB(size)} kb</span> */}
                </div>
            </div>
            {children}
        </div>
    )
}

export default FileItem
